import React from 'react';
import { motion } from 'framer-motion';
import { Target, Zap, BatteryCharging } from 'lucide-react';
const pillars = [{
  icon: Target,
  text: 'Enfoque Láser'
}, {
  icon: Zap,
  text: 'Potencia Biológica'
}, {
  icon: BatteryCharging,
  text: 'Energía Inagotable'
}];
export function Authority() {
  return <section className="py-16 px-4 bg-brand-dark" data-id="element-31">
      <div className="max-w-5xl mx-auto text-center" data-id="element-32">
        <motion.p className="text-xl md:text-2xl font-display font-bold text-brand-muted uppercase tracking-wide mb-12" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-33">
          Diseñado bajo principios de{' '}
          <span className="text-white" data-id="element-34">Biohacking Avanzado</span> y{' '}
          <span className="text-white" data-id="element-35">Optimización Masculina</span>.
        </motion.p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-36">
          {pillars.map((pillar, idx) => <motion.div key={idx} className="flex flex-col items-center justify-center p-6 bg-brand-darker border border-brand-gray rounded-lg hover:border-brand-orange/50 transition-colors" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} data-id="element-37">
              <pillar.icon className="w-12 h-12 text-brand-orange mb-4" data-id="element-38" />
              <h3 className="text-xl font-bold text-white uppercase tracking-wider" data-id="element-39">
                {pillar.text}
              </h3>
            </motion.div>)}
        </div>
      </div>
    </section>;
}